import React, { useContext } from 'react'
import LeftContent from 'modules/react/signup/LeftContent'
import RightContent from 'modules/react/signup/RightContent'
import SignupContext from 'modules/react/signup/SignupContext'
import FormElementError from 'modules/react/signup/FormElementError'
import CourseSummary from 'modules/react/signup/CourseSummary'
import ProgressBar from 'modules/react/signup/ProgressBar'
import ProgressBarStep from 'modules/react/signup/ProgressBarStep'

export default function Step3Company () {

  const signupContext = useContext(SignupContext)
  const { goBack, goToNextStep, setFormValue, getFormValue, submit, restUrls, setEnterCallback, course } = signupContext

  const [participants, setParticipants] = React.useState(getFormValue('participants', []))

  React.useEffect(() => {
      setEnterCallback(() => completeSignup)
    }, []
  )
  React.useEffect(() => {
    if (participants.length === 0) {
      addParticipant()
    }
  }, [])

  const addParticipant = () => {
    let newParticipantsArray = Array.from(participants)

    newParticipantsArray.push({ name: '', email: '' })

    setParticipants(newParticipantsArray)
    setFormValue('participants', newParticipantsArray)
  }

  const removeParticipant = (participantNumber) => {
    let newParticipantsArray = Array.from(participants)

    newParticipantsArray.splice(participantNumber, 1)

    setParticipants(newParticipantsArray)
    setFormValue('participants', newParticipantsArray)
  }

  const completeSignup = () => {

    submit(restUrls.company.signup)
      .then((response) => {
        goToNextStep()
      })
  }

  return (
    <>
      <LeftContent>
        <ProgressBar>
          <ProgressBarStep text={'Oplysninger'} active={true} previous={true}/>
          <ProgressBarStep text={'Deltagerinformation'} active={true} current={true}/>
          <ProgressBarStep text={'Du er tilmeldt!'}/>
        </ProgressBar>

        <div className="title title--h3">Udfyld deltagere</div>
        <div className="participants">
          {participants.map((participant, index) => {

            const nameFieldName = `participants.${index}.name`
            const emailFieldName = `participants.${index}.email`

            return (
              <div className="participant" key={index}>
                <div className="participant__header">
                  <div className="participant__name">Deltager {index + 1}</div>
                  <div className="participant__price">Pris per deltager - {course.formatted_price}</div>
                  <button className="delete-button" onClick={() => removeParticipant(index)}></button>
                </div>

                <div className="input-group">
                  <div className="input-wrap">
                    <FormElementError name={nameFieldName}>
                      <input defaultValue={participant.name} type="text" placeholder="Navn:"
                             onChange={(e) => setFormValue(nameFieldName, e.target.value)}/>
                    </FormElementError>
                  </div>
                  <div className="input-wrap">
                    <FormElementError name={emailFieldName}>
                      <input defaultValue={participant.email} type="text" placeholder="Mailadresse:"
                             onChange={(e) => setFormValue(emailFieldName, e.target.value)}/>
                    </FormElementError>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        <button className="participants__add" onClick={addParticipant}>
          <div className="add-button"></div>
          Tilføj deltager
        </button>
        <div className="button-section button-section--modal-group">
          <button className="inline-button inline-button--prim inline-button--back" onClick={goBack}>Tilbage</button>
          <button className="button button--next" onClick={completeSignup}>Bekræft</button>
        </div>
      </LeftContent>
      <RightContent>
        <CourseSummary paymentType="Virksomhed"/>
      </RightContent>
    </>
  )
}